import { AbstractPaymentStoreRequest } from '@models/requests/abstract-payment-store-request.model';

export class PaymentGiftCardStoreRequest extends AbstractPaymentStoreRequest {
  public charge_type: string = 'charge_gift_card';
  public gift_card_code: string;

  public constructor(giftCardCode: string, chargeAmount: number, orderId: string) {
    super(orderId, chargeAmount);
    this.gift_card_code = giftCardCode;
  }
}
